import { useRef } from 'react';
import haptic from '../utils/haptic';

// Deslizar a la derecha para volver, igual que el gesto de atrás del sistema.
// Devuelve las props para el contenedor de la pantalla; se usan con spread.
//
// Vive acá y no copiado en cada editor porque el umbral y el pulso tienen que
// sentirse iguales en los cuatro: tres copias del mismo gesto terminan
// divirtiéndose sin que nadie lo note.
export default function useSwipeBack(onClose) {
  const inicio = useRef(null);

  return {
    onTouchStart(event) {
      const touch = event.touches?.[0];
      inicio.current = touch ? { x: touch.clientX, y: touch.clientY } : null;
    },
    onTouchEnd(event) {
      const start = inicio.current;
      inicio.current = null;
      const touch = event.changedTouches?.[0];
      if (!start || !touch) return;
      const dx = touch.clientX - start.x;
      const dy = touch.clientY - start.y;
      // Bastante recorrido horizontal y poco vertical: así no se dispara
      // mientras se scrollea la pantalla.
      if (dx > 72 && Math.abs(dy) < 48) {
        haptic.untick();
        onClose?.();
      }
    },
  };
}
